// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import passwordResetRequestHandler from 'app/common/react/components/PasswordReset/utils/passwordResetRequestHandler';
import { Button } from 'gestalt';

type Props = {|
  callBack: () => void,
  color?: 'red' | 'gray',
  email: string,
  inline?: boolean,
  overrideText?: string,
|};

export default function ResetPasswordButton(props: Props) {
  const resetPasswordText = i18n._('Reset password', 'Request a password reset email');
  return (
    <Button
      accessibilityLabel={resetPasswordText}
      color={props.color || 'red'}
      inline={props.inline}
      onClick={() => {
        passwordResetRequestHandler({
          usernameOrEmail: props.email,
          callBack: props.callBack,
        });
      }}
      text={props.overrideText || resetPasswordText}
    />
  );
}
